var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63616 2.66669 2.66663 8.63622 2.66663 16C2.66663 23.3638 8.63616 29.3334 16 29.3334ZM23.6701 11.5447C24.155 10.9905 24.0988 10.1482 23.5446 9.66325C22.9904 9.17834 22.1481 9.2345 21.6632 9.78868L13.2683 19.3828L10.2761 16.3905C9.7554 15.8698 8.91118 15.8698 8.39048 16.3905C7.86978 16.9112 7.86978 17.7555 8.39048 18.2762L12.3905 22.2762C12.6514 22.5371 13.0088 22.6782 13.3777 22.6659C13.7465 22.6537 14.0937 22.4891 14.3367 22.2114L23.6701 11.5447Z",
    fill: "#338808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/alert-success.68bc0695724fdd8f85eb03a1704fbc3a.svg";
export { ForwardRef as ReactComponent };